import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';
import { CompetitorsLocationsDtoSchema } from '../contracts';

export const GetCompetitorsLocationsRequestDtoSchema = z.object({
  facilityId: z.number(),
  from: z.string(),
  to: z.string(),
  comparisonSet: z.enum(['INTERNAL', 'COMP']).optional(),
});

export const GetCompetitorsLocationsResponseDtoSchema = z.array(
  CompetitorsLocationsDtoSchema
);

export type GetCompetitorsLocationsRequestDto = z.infer<
  typeof GetCompetitorsLocationsRequestDtoSchema
>;

export type GetCompetitorsLocationsResponseDto = z.infer<
  typeof GetCompetitorsLocationsResponseDtoSchema
>;

export const getCompetitorsLocations = async (
  params: GetCompetitorsLocationsRequestDto,
  config?: AxiosRequestConfig<GetCompetitorsLocationsRequestDto>
) => {
  const { facilityId, ...restParams } = params;

  return api
    .get(
      `/market-intelligence/facilities/${facilityId}/competitors-locations`,
      {
        params: restParams,
        ...config,
      }
    )
    .then(responseContract(GetCompetitorsLocationsResponseDtoSchema));
};
